/* eslint-disable no-console */
import _ from 'lodash';
import { createTheme } from '@mui/material/styles';
import typography from './typography';
import { colors } from '@mui/material';
// const baseConfig = {
//   direction: 'ltr',
//   typography,
//   overrides: {
//     MuiLinearProgress: {
//       root: {
//         borderRadius: 3,
//         overflow: 'hidden'
//       }
//     },

//     MuiListItemIcon: {
//       root: {
//         minWidth: 32
//       }
//     },
//     MuiTableCell: {
//       root: {
//         padding: '0px 0px 0px 15px'
//       }
//     },
//     MuiTableRow: {
//       root: {
//         '&:nth-of-type(odd)': {
//           backgroundColor: '#F8F8F8'
//         }
//       }
//     },
//     MuiChip: {
//       root: {
//         backgroundColor: 'rgba(0,0,0,0.075)'
//       }
//     }
//   }
// };

// const themeConfigs = [
//   {
//     name: THEMES.LIGHT,
//     overrides: {
//       MuiInputBase: {
//         input: {
//           '&::placeholder': {
//             opacity: 1,
//             color: colors.blueGrey[600]
//           }
//         }
//       }
//     },
//     palette: {
//       type: 'light',
//       action: {
//         active: colors.blueGrey[600]
//       },
//       background: {
//         default: colors.common.white,
//         dark: '#f4f6f8',
//         paper: colors.common.white
//       },
//       primary: {
//         main: '#20aaf5',
//         contrastText: '#fff'
//       },
//       secondary: {
//         main: '#20aaf5',
//         contrastText: '#fff'
//       },
//       text: {
//         primary: colors.blueGrey[900],
//         secondary: colors.blueGrey[600]
//       }
//     },
//     shadows: softShadows
//   },
//   {
//     name: THEMES.ONE_DARK,
//     palette: {
//       type: 'dark',
//       action: {
//         active: 'rgba(255, 255, 255, 0.54)',
//         hover: 'rgba(255, 255, 255, 0.04)',
//         selected: 'rgba(255, 255, 255, 0.08)',
//         disabled: 'rgba(255, 255, 255, 0.26)',
//         disabledBackground: 'rgba(255, 255, 255, 0.12)',
//         focus: 'rgba(255, 255, 255, 0.12)'
//       },
//       background: {
//         default: '#282C34',
//         dark: '#1c2025',
//         paper: '#282C34'
//       },
//       primary: {
//         main: '#8a85ff'
//       },
//       secondary: {
//         main: '#8a85ff'
//       },
//       text: {
//         primary: '#e6e5e8',
//         secondary: '#adb0bb'
//       }
//     },
//     shadows: strongShadows
//   },
// ];

const mdTheme = createTheme({
  typography: typography,
  palette: {
    action: {
      active: colors.blueGrey[600]
    },
    background: {
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#20aaf5',
      contrastText: '#fff'
    },
    secondary: {
      main: '#20aaf5',
      contrastText: '#fff'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows: [
    'none',
    '0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)'
  ],
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 3,
          overflow: 'hidden'
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 32
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '0px 0px 0px 15px'
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: '#F8F8F8'
          }
        }
      }
    },
    // MuiChip: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: 'rgba(0,0,0,0.075)'
    //     }
    //   }
    // },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            opacity: 1,
            color: colors.blueGrey[600]
          }
        }
      }
    }
  }
});

export default mdTheme;
